import { useEffect, useState } from "react";
import { Landmark } from "lucide-react";
import api from "@/lib/api";
import { BenefitCard } from "@/components/BenefitCard";

// Finance & Banking affiliate rail — credit cards / loans / insurance from Cuelinks, rendered as
// Benefit Cards. Silent no-op when nothing matches.
export const FinanceDeals = ({ q = "", subtype = "", limit = 12, title = "Finance & Banking offers" }) => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let live = true; setLoading(true);
    const p = new URLSearchParams({ limit: String(limit) });
    if (q) p.set("q", q);
    if (subtype) p.set("subtype", subtype);
    api.get(`/marketplace/public/finance-deals?${p.toString()}`)
      .then((r) => { if (live) setDeals(r.data?.enabled ? (r.data.deals || []) : []); })
      .catch(() => { if (live) setDeals([]); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [q, subtype, limit]);
  if (!loading && deals.length === 0) return null;
  return (
    <div className="mt-8" data-testid="finance-deals">
      <h3 className="mb-3 flex items-center gap-2 text-base font-semibold text-slate-700"><Landmark className="h-4 w-4 text-indigo-500" />{title}<span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-500">Affiliate</span></h3>
      {loading ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{[0, 1, 2].map((i) => <div key={i} className="h-56 animate-pulse rounded-2xl bg-white/70" />)}</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{deals.map((d) => <BenefitCard key={d.id} d={d} />)}</div>
      )}
    </div>
  );
};

export default FinanceDeals;
